import { Component, OnInit } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Role, RoleAdapter } from '../models/role';
import { People } from '../models/people';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { RolesService } from '../services/roles.service';
import { CommonModule } from '@angular/common';
import { TimelineModule } from 'primeng/timeline';
import { TranslatePipe } from '@ngx-translate/core';
import { EventsComponent } from '../_utils/components/events/events.component';
import { PeopleStatusComponent } from '../_utils/components/people-status/people-status.component';
import { AvatarComponent } from '../_utils/components/avatar/avatar.component';
import { PeopleStatusIconComponent } from '../_utils/components/people-status-icon/people-status-icon.component';
import { getPersonHiringStatusClass, getPersonStatusIconAndMessage } from '../_utils/people_util';

@Component({
  selector: 'app-role',
  standalone: true,
  imports: [CommonModule, RouterModule, TimelineModule, TranslatePipe, EventsComponent,PeopleStatusComponent, AvatarComponent,PeopleStatusIconComponent],
  templateUrl: './role.component.html',
  styleUrl: './role.component.scss'
})

export class RoleComponent  implements OnInit {

  roleId: number = 0;
  role?: Role;
  peoples: People[]=[];

  //method mapping for template access
  public getPersonHiringStatusClass = getPersonHiringStatusClass;
  public getPersonStatusIconAndMessage = getPersonStatusIconAndMessage;

  constructor(private route: ActivatedRoute,
    private rolesService : RolesService, 
    private roleAdapter: RoleAdapter,
  ) { }

  ngOnInit(): void{
    this.roleId = this.route.snapshot.params['id'];
    this.fecthRole();
  }

  fecthRole() {
    this.rolesService.getRole(this.roleId).pipe(
      map((item:any) => this.roleAdapter.adapt(item))
    ).subscribe(
      (res: Role) => {
      this.role = res;
    });
  }

  trackByAssociatedTeam(index: number, item: { team: any; requiredFte: number }): number | undefined {
    return item?.team?.id; 
  }
}
